import { Typography } from "@mui/material";
import styles from "./index.module.css";
import { forwardRef } from "react";

type BasicStepProps = {
	description: React.ReactNode;
	children: React.ReactNode;
};

export const BasicStep = forwardRef<HTMLDivElement, BasicStepProps>(function BasicStep({ description, children }, ref) {
	return (
		<div className={styles.basicStepContainer} ref={ref}>
			<Typography className={styles.stepDescription}>{description}</Typography>
			{children}
		</div>
	);
});
